import { render, staticRenderFns } from "./SelectUser.vue?vue&type=template&id=1c70b6df&scoped=true&"
import script from "./SelectUser.vue?vue&type=script&lang=js&"
export * from "./SelectUser.vue?vue&type=script&lang=js&"
import style0 from "./SelectUser.vue?vue&type=style&index=0&id=1c70b6df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c70b6df",
  null
  
)

export default component.exports